<template>
  <div class="gerenciar-destaques">
    <div class="secao-header">
      <h2>Gerenciar Carrossel de Destaques</h2>
      <button
        class="btn-preview"
        @click="openPreview"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
        >
          <circle
            cx="12"
            cy="12"
            r="1"
          ></circle>
          <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
        </svg>
        <span>Visualizar Preview</span>
      </button>
    </div>

    <!-- FORMULÁRIO DE CADASTRO -->
    <form
      @submit.prevent="adicionarDestaque"
      class="destaque-form"
    >
      <h3>Novo Destaque</h3>

      <div class="form-grid">
        <!-- Upload de Imagem -->
        <div class="form-group upload-group">
          <label class="field-label">Imagem do Destaque</label>
          <div
            class="image-upload-box"
            :class="{ 'has-preview': imagePreview }"
            @click="triggerFileInput"
          >
            <input
              type="file"
              ref="fileInput"
              accept="image/png, image/jpeg, image/webp"
              @change="onFileSelected"
              style="display: none"
            />
            <div
              v-if="!imagePreview"
              class="upload-prompt"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="28"
                height="28"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="1.5"
              >
                <rect
                  x="3"
                  y="3"
                  width="18"
                  height="18"
                  rx="2"
                  ry="2"
                />
                <circle
                  cx="8.5"
                  cy="8.5"
                  r="1.5"
                />
                <polyline points="21 15 16 10 5 21" />
              </svg>
              <span>Selecionar Imagem</span>
              <small>Recomendado: 1000x450 (PNG, JPG)</small>
            </div>
            <div
              v-else
              class="preview-wrapper"
            >
              <img
                :src="imagePreview"
                alt="Preview"
                class="image-preview"
              />
              <div class="change-overlay">Alterar Imagem</div>
            </div>
          </div>
        </div>

        <!-- Inputs de texto -->
        <div class="text-inputs-group">
          <div class="form-group">
            <label
              for="descricaoImagem"
              class="field-label"
              >Descrição da Imagem (Acessibilidade Alt) *</label
            >
            <textarea
              id="descricaoImagem"
              v-model="novoDestaque.descricaoImagem"
              placeholder="Descreva detalhadamente a imagem para leitores de tela..."
              rows="3"
              required
            ></textarea>
          </div>

          <div class="form-group">
            <label
              for="linkNoticia"
              class="field-label"
              >Link de Redirecionamento *</label
            >
            <input
              type="text"
              id="linkNoticia"
              v-model="novoDestaque.linkNoticia"
              placeholder="Ex: /noticias/resultado-edital ou https://ufc.br/noticias"
              required
            />
          </div>

          <button
            type="submit"
            class="btn-submit"
            :disabled="loading || !novoDestaque.imagem"
          >
            <span v-if="!loading">Adicionar ao Carrossel</span>
            <span v-else>Enviando...</span>
          </button>
        </div>
      </div>
    </form>

    <!-- LISTA ORDENÁVEL DRAG-AND-DROP -->
    <div class="destaques-list-container">
      <h3>Destaques Ativos (Arraste para reordenar)</h3>
      <div
        v-if="destaques.length === 0"
        class="sem-destaques"
      >
        <p>
          Nenhum destaque cadastrado no momento. O carrossel usará notícias como
          fallback na tela inicial.
        </p>
      </div>
      <div
        v-else
        class="destaques-drag-list"
      >
        <div
          v-for="(destaque, index) in destaques"
          :key="destaque.id"
          class="destaque-drag-item"
          draggable="true"
          @dragstart="onDragStart($event, index)"
          @dragover.prevent
          @dragenter="onDragEnter(index)"
          @dragend="onDragEnd"
          @drop="onDrop($event, index)"
        >
          <!-- Handle/Indicador de arrasto -->
          <div class="drag-handle">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
            >
              <circle
                cx="9"
                cy="5"
                r="1"
              ></circle>
              <circle
                cx="9"
                cy="12"
                r="1"
              ></circle>
              <circle
                cx="9"
                cy="19"
                r="1"
              ></circle>
              <circle
                cx="15"
                cy="5"
                r="1"
              ></circle>
              <circle
                cx="15"
                cy="12"
                r="1"
              ></circle>
              <circle
                cx="15"
                cy="19"
                r="1"
              ></circle>
            </svg>
          </div>

          <div class="item-index">#{{ index + 1 }}</div>

          <div class="item-img-preview">
            <img
              :src="destaque.imagemUrl"
              :alt="destaque.descricaoImagem"
            />
          </div>

          <div class="item-info">
            <p class="item-desc">{{ destaque.descricaoImagem }}</p>
            <span class="item-link">{{ destaque.linkNoticia }}</span>
          </div>

          <button
            class="btn-excluir"
            @click="excluirDestaque(destaque.id, index)"
            title="Excluir destaque"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <polyline points="3 6 5 6 21 6"></polyline>
              <path
                d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"
              ></path>
            </svg>
          </button>
        </div>
      </div>
    </div>

    <!-- MODAL DE PREVIEW -->
    <div
      v-if="showPreview"
      class="preview-modal-overlay"
      @click.self="showPreview = false"
    >
      <div class="preview-modal-content">
        <div class="modal-header">
          <h3>Pré-visualização do Carrossel</h3>
          <button
            class="btn-close"
            @click="showPreview = false"
          >
            &times;
          </button>
        </div>
        <div class="modal-body">
          <!-- Renderiza o carrossel passando a lista de destaques locais -->
          <DestaquesCarousel :destaques="destaquesPreviewList" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted, computed } from "vue";
import noticiaService from "@/service/noticiaService";
import DestaquesCarousel from "@/components/noticias/DestaquesCarousel.vue";

const destaques = ref([]);
const loading = ref(false);
const imagePreview = ref(null);
const fileInput = ref(null);
const showPreview = ref(false);
const draggedIndex = ref(null);

const novoDestaque = reactive({
  imagem: null,
  descricaoImagem: "",
  linkNoticia: "",
});

// Fallback para preview caso a lista esteja vazia
const destaquesPreviewList = computed(() => {
  if (destaques.value.length > 0) {
    return destaques.value;
  }
  // Fallback fictício para que o admin veja como funciona o layout
  return [
    {
      id: "ficticio-1",
      imagemUrl:
        "https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?q=80&w=800&auto=format&fit=crop",
      descricaoImagem:
        "Preview Fictício: Inscrições abertas para novos projetos de Extensão",
      linkNoticia: "#",
    },
  ];
});

async function carregarDestaques() {
  try {
    const list = await noticiaService.getDestaques();
    destaques.value = list ? list.sort((a, b) => a.ordem - b.ordem) : [];
  } catch (error) {
    console.error("Erro ao carregar destaques:", error);
  }
}

function triggerFileInput() {
  if (fileInput.value) {
    fileInput.value.click();
  }
}

function onFileSelected(event) {
  const file = event.target.files[0];
  if (!file) return;

  if (!file.type.startsWith("image/")) {
    alert("Por favor, selecione uma imagem válida.");
    return;
  }

  // Preview local
  const reader = new FileReader();
  reader.onload = (e) => {
    imagePreview.value = e.target.result;

    // Converte para base64 limpando o prefixo da DataURL
    const base64String = e.target.result.split(",")[1];

    novoDestaque.imagem = {
      fileName: file.name,
      mimeType: file.type,
      base64Data: base64String,
    };
  };
  reader.readAsDataURL(file);
}

async function adicionarDestaque() {
  if (
    !novoDestaque.imagem ||
    !novoDestaque.descricaoImagem ||
    !novoDestaque.linkNoticia
  )
    return;
  loading.value = true;
  try {
    await noticiaService.postDestaque({
      imagem: novoDestaque.imagem,
      descricaoImagem: novoDestaque.descricaoImagem,
      linkNoticia: novoDestaque.linkNoticia,
    });

    // Reset formulário
    novoDestaque.imagem = null;
    novoDestaque.descricaoImagem = "";
    novoDestaque.linkNoticia = "";
    imagePreview.value = null;
    if (fileInput.value) fileInput.value.value = "";

    await carregarDestaques();
    alert("Destaque adicionado com sucesso!");
  } catch (error) {
    console.error("Erro ao cadastrar destaque:", error);
    alert("Falha ao adicionar destaque.");
  } finally {
    loading.value = false;
  }
}

async function excluirDestaque(id, index) {
  if (!confirm("Deseja realmente remover este destaque do carrossel?")) return;
  try {
    await noticiaService.excluirDestaque(id);
    destaques.value.splice(index, 1);
  } catch (error) {
    console.error("Erro ao excluir destaque:", error);
    alert("Falha ao excluir destaque.");
  }
}

// ========== LOGICA DRAG AND DROP NATAL EM VUE/HTML5 ==========
function onDragStart(event, index) {
  draggedIndex.value = index;
  event.dataTransfer.effectAllowed = "move";
  // Adiciona estilo opaco ao item arrastado
  event.target.classList.add("dragging");
}

function onDragEnter(index) {
  if (draggedIndex.value === null || draggedIndex.value === index) return;
  // Reordena localmente a lista
  const item = destaques.value.splice(draggedIndex.value, 1)[0];
  destaques.value.splice(index, 0, item);
  draggedIndex.value = index;
}

function onDragEnd(event) {
  event.target.classList.remove("dragging");
  draggedIndex.value = null;
}

async function onDrop(event, index) {
  draggedIndex.value = null;
  // Envia a nova ordenação ao backend
  const idsOrdenados = destaques.value.map((d) => d.id);
  try {
    await noticiaService.reordenarDestaques({
      destaquesOrdenados: idsOrdenados,
    });
  } catch (error) {
    console.error("Erro ao salvar ordenação:", error);
    alert("Falha ao sincronizar ordenação com o servidor.");
    await carregarDestaques(); // Recarrega ordem original em caso de falha
  }
}

function openPreview() {
  showPreview.value = true;
}

onMounted(() => {
  carregarDestaques();
});
</script>

<style scoped>
.gerenciar-destaques {
  color: white;
  font-family: "Poppins", sans-serif;
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
}

.secao-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.secao-header h2 {
  font-size: 1.3rem;
  font-weight: 600;
  margin: 0;
}

.btn-preview {
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.15);
  color: white;
  padding: 8px 16px;
  border-radius: 6px;
  font-size: 0.85rem;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.2s ease;
}

.btn-preview:hover {
  background: rgba(255, 255, 255, 0.15);
  border-color: rgba(255, 255, 255, 0.3);
}

/* ========== FORMULÁRIO ========== */
.destaque-form {
  background: #25164f;
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 8px;
  padding: 20px;
}

.destaque-form h3 {
  font-size: 1rem;
  font-weight: 600;
  margin: 0 0 16px;
  color: #a78bfa;
}

.form-grid {
  display: flex;
  gap: 20px;
}

.upload-group {
  flex-shrink: 0;
  width: 240px;
}

.text-inputs-group {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.field-label {
  font-size: 0.82rem;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.85);
}

.image-upload-box {
  border: 2px dashed rgba(255, 255, 255, 0.15);
  background: #1d1042;
  border-radius: 8px;
  height: 155px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  overflow: hidden;
  transition: all 0.2s ease;
}

.image-upload-box:hover {
  border-color: #7c3aed;
  background: #221250;
}

.upload-prompt {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 12px;
  color: rgba(255, 255, 255, 0.6);
}

.upload-prompt span {
  font-size: 0.8rem;
  font-weight: 500;
  margin: 6px 0 2px;
  color: white;
}

.upload-prompt small {
  font-size: 0.68rem;
  opacity: 0.8;
}

.preview-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
}

.image-preview {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.change-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.8rem;
  font-weight: 500;
  opacity: 0;
  transition: opacity 0.2s ease;
}

.preview-wrapper:hover .change-overlay {
  opacity: 1;
}

/* Inputs */
textarea,
input[type="text"] {
  background: #1d1042;
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: white;
  padding: 10px 14px;
  border-radius: 6px;
  font-family: inherit;
  font-size: 0.82rem;
  outline: none;
  transition: border-color 0.2s;
}

textarea:focus,
input[type="text"]:focus {
  border-color: #7c3aed;
}

textarea {
  resize: vertical;
}

.btn-submit {
  background: #7c3aed;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 6px;
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-top: 6px;
  align-self: flex-start;
}

.btn-submit:hover:not(:disabled) {
  background: #6d28d9;
}

.btn-submit:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* ========== DRAG LIST ========== */
.destaques-list-container {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.destaques-list-container h3 {
  font-size: 1rem;
  font-weight: 600;
  margin: 0;
  color: rgba(255, 255, 255, 0.9);
}

.sem-destaques {
  background: rgba(255, 255, 255, 0.02);
  border: 1px dashed rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  padding: 24px;
  text-align: center;
  color: rgba(255, 255, 255, 0.5);
  font-size: 0.82rem;
}

.destaques-drag-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.destaque-drag-item {
  display: flex;
  align-items: center;
  background: #25164f;
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 8px;
  padding: 10px 16px;
  gap: 16px;
  cursor: grab;
  transition:
    background 0.2s,
    border-color 0.2s;
}

.destaque-drag-item:hover {
  background: #2d1a6e;
  border-color: rgba(255, 255, 255, 0.15);
}

.destaque-drag-item.dragging {
  opacity: 0.5;
  border: 1px dashed #7c3aed;
  background: #1d1042;
}

.drag-handle {
  color: rgba(255, 255, 255, 0.3);
  cursor: grab;
  display: flex;
  align-items: center;
}

.item-index {
  font-size: 0.8rem;
  font-weight: 600;
  color: #a78bfa;
  min-width: 24px;
}

.item-img-preview {
  width: 70px;
  height: 42px;
  border-radius: 4px;
  overflow: hidden;
  flex-shrink: 0;
}

.item-img-preview img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.item-info {
  flex: 1;
  min-width: 0;
}

.item-desc {
  font-size: 0.82rem;
  font-weight: 500;
  margin: 0 0 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.item-link {
  font-size: 0.7rem;
  color: rgba(255, 255, 255, 0.5);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
}

.btn-excluir {
  background: transparent;
  border: none;
  color: rgba(255, 255, 255, 0.4);
  cursor: pointer;
  padding: 6px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}

.btn-excluir:hover {
  color: #ef4444;
  background: rgba(239, 68, 68, 0.1);
}

/* ========== MODAL DE PREVIEW ========== */
.preview-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(4px);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.preview-modal-content {
  background: #1a0f3e;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  width: 90%;
  max-width: 900px;
  overflow: hidden;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.5);
  animation: modalIn 0.3s ease-out;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  background: #25164f;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}

.modal-header h3 {
  font-size: 1rem;
  font-weight: 600;
  margin: 0;
  color: white;
}

.btn-close {
  background: transparent;
  border: none;
  color: white;
  font-size: 1.5rem;
  cursor: pointer;
  line-height: 1;
}

.modal-body {
  padding: 20px;
}

@keyframes modalIn {
  from {
    opacity: 0;
    transform: scale(0.95) translateY(10px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

/* ========== RESPONSIVO ========== */
@media (max-width: 768px) {
  .form-grid {
    flex-direction: column;
  }

  .upload-group {
    width: 100%;
  }

  .image-upload-box {
    height: 140px;
  }
}
</style>
